import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["sku"],
  _excluded2 = ["sku"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import qs from 'query-string';
import createRequest from './request';
import { getAnonymousId } from '../analytics/utils';
export var createRequestConfig = function createRequestConfig() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    authToken = _ref.authToken,
    orderToken = _ref.orderToken;
  var config = {
    headers: {}
  };
  if (authToken) {
    config.headers.Authorization = authToken;
  } else if (orderToken) {
    config.headers['X-Spree-Order-Token'] = orderToken;
  }
  try {
    var anonymousId = getAnonymousId();
    if (anonymousId) {
      config.headers['ACS-Anonymous-Id'] = anonymousId;
    }
  } catch (error) {
    console.error(error);
  }
  return config;
};
export var createOMSClient = function createOMSClient(omsClientConfig) {
  var request = createRequest(omsClientConfig);
  var client = {
    createOrder: function () {
      var _createOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(authToken, data) {
        var url, defaultData, config, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = '/api/orders';
              defaultData = {
                lineItemsAttributes: []
              };
              config = createRequestConfig({
                authToken: authToken
              });
              _context.next = 5;
              return request.post(url, data || defaultData, config);
            case 5:
              response = _context.sent;
              return _context.abrupt("return", response.data);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function createOrder(_x, _x2) {
        return _createOrder.apply(this, arguments);
      }
      return createOrder;
    }(),
    getOrder: function () {
      var _getOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(order, authToken) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = "/api/orders/".concat(order.number);
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context2.next = 4;
              return request.get(url, config);
            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getOrder(_x3, _x4) {
        return _getOrder.apply(this, arguments);
      }
      return getOrder;
    }(),
    getCurrentOrder: function () {
      var _getCurrentOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(authToken) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              url = '/api/orders/current';
              config = createRequestConfig({
                authToken: authToken
              });
              _context3.next = 4;
              return request.get(url, config);
            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getCurrentOrder(_x5) {
        return _getCurrentOrder.apply(this, arguments);
      }
      return getCurrentOrder;
    }(),
    updateOrder: function () {
      var _updateOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(order, authToken, data) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = "/api/orders/".concat(order.number);
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context4.next = 4;
              return request.patch(url, data, config);
            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function updateOrder(_x6, _x7, _x8) {
        return _updateOrder.apply(this, arguments);
      }
      return updateOrder;
    }(),
    emptyOrder: function () {
      var _emptyOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(order, authToken) {
        var url, config;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = "/api/orders/".concat(order.number, "/empty");
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context5.next = 4;
              return request.put(url, null, config);
            case 4:
              return _context5.abrupt("return", true);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function emptyOrder(_x9, _x10) {
        return _emptyOrder.apply(this, arguments);
      }
      return emptyOrder;
    }(),
    addLineItem: function () {
      var _addLineItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(order, authToken, data) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              url = "/api/orders/".concat(order.number, "/line_items");
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context6.next = 4;
              return request.post(url, data, config);
            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function addLineItem(_x11, _x12, _x13) {
        return _addLineItem.apply(this, arguments);
      }
      return addLineItem;
    }(),
    removeLineItem: function () {
      var _removeLineItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(order, authToken, lineItemId) {
        var url, config;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              url = "/api/orders/".concat(order.number, "/line_items/").concat(lineItemId);
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context7.next = 4;
              return request.delete(url, config);
            case 4:
              return _context7.abrupt("return", undefined);
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function removeLineItem(_x14, _x15, _x16) {
        return _removeLineItem.apply(this, arguments);
      }
      return removeLineItem;
    }(),
    updateLineItem: function () {
      var _updateLineItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(order, authToken, lineItemId, data) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              url = "/api/orders/".concat(order.number, "/line_items/").concat(lineItemId);
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context8.next = 4;
              return request.patch(url, data, config);
            case 4:
              response = _context8.sent;
              return _context8.abrupt("return", response.data);
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function updateLineItem(_x17, _x18, _x19, _x20) {
        return _updateLineItem.apply(this, arguments);
      }
      return updateLineItem;
    }(),
    updateGiftCards: function () {
      var _updateGiftCards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(order, data) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              url = "/api/orders/".concat(order.number, "/gift_cards/bulk_update");
              config = createRequestConfig({
                orderToken: order.token
              });
              _context9.next = 4;
              return request.patch(url, data, config);
            case 4:
              response = _context9.sent;
              return _context9.abrupt("return", response.data);
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function updateGiftCards(_x21, _x22) {
        return _updateGiftCards.apply(this, arguments);
      }
      return updateGiftCards;
    }(),
    addCouponCode: function () {
      var _addCouponCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(order, authToken, couponCode) {
        var url, data, config, response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              url = "/api/orders/".concat(order.number, "/coupon_codes");
              data = {
                couponCode: couponCode
              };
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context10.next = 5;
              return request.post(url, data, config);
            case 5:
              response = _context10.sent;
              return _context10.abrupt("return", response.data);
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      function addCouponCode(_x23, _x24, _x25) {
        return _addCouponCode.apply(this, arguments);
      }
      return addCouponCode;
    }(),
    removeCouponCode: function () {
      var _removeCouponCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(order, authToken, couponCode) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              url = "/api/orders/".concat(order.number, "/coupon_codes/").concat(couponCode);
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context11.next = 4;
              return request.delete(url, config);
            case 4:
              response = _context11.sent;
              return _context11.abrupt("return", response.data);
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      function removeCouponCode(_x26, _x27, _x28) {
        return _removeCouponCode.apply(this, arguments);
      }
      return removeCouponCode;
    }(),
    prepareCheckout: function () {
      var _prepareCheckout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(order, authToken) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              url = "/api/checkouts/".concat(order.number, "/prepare");
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context12.next = 4;
              return request.put(url, null, config);
            case 4:
              response = _context12.sent;
              return _context12.abrupt("return", response.data);
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      function prepareCheckout(_x29, _x30) {
        return _prepareCheckout.apply(this, arguments);
      }
      return prepareCheckout;
    }(),
    calculateShippingOptions: function () {
      var _calculateShippingOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(order, authToken, shippingDetails) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              url = "/api/checkouts/".concat(order.number, "/calculate_shipping_options");
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context13.next = 4;
              return request.post(url, shippingDetails, config);
            case 4:
              response = _context13.sent;
              return _context13.abrupt("return", response.data);
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      function calculateShippingOptions(_x31, _x32, _x33) {
        return _calculateShippingOptions.apply(this, arguments);
      }
      return calculateShippingOptions;
    }(),
    finalizeCheckout: function () {
      var _finalizeCheckout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(order, authToken, data) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              url = "/api/checkouts/".concat(order.number, "/finalize");
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context14.next = 4;
              return request.put(url, data, config);
            case 4:
              response = _context14.sent;
              return _context14.abrupt("return", response.data);
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      function finalizeCheckout(_x34, _x35, _x36) {
        return _finalizeCheckout.apply(this, arguments);
      }
      return finalizeCheckout;
    }(),
    updateCheckout: function () {
      var _updateCheckout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(order, authToken, data) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              url = "/api/checkouts/".concat(order.number);
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context15.next = 4;
              return request.patch(url, data, config);
            case 4:
              response = _context15.sent;
              return _context15.abrupt("return", response.data);
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      function updateCheckout(_x37, _x38, _x39) {
        return _updateCheckout.apply(this, arguments);
      }
      return updateCheckout;
    }(),
    crossSell: function () {
      var _crossSell = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(order, authToken, data) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              url = "/api/orders/".concat(order.number, "/cross_sell");
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context16.next = 4;
              return request.put(url, data, config);
            case 4:
              response = _context16.sent;
              return _context16.abrupt("return", response.data);
            case 6:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
      function crossSell(_x40, _x41, _x42) {
        return _crossSell.apply(this, arguments);
      }
      return crossSell;
    }(),
    getReferralIdentifier: function () {
      var _getReferralIdentifier = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(data) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              url = '/api/referral_identifiers';
              config = createRequestConfig();
              _context17.next = 4;
              return request.post(url, data, config);
            case 4:
              response = _context17.sent;
              return _context17.abrupt("return", response.data);
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
      function getReferralIdentifier(_x43) {
        return _getReferralIdentifier.apply(this, arguments);
      }
      return getReferralIdentifier;
    }(),
    getCountryStates: function () {
      var _getCountryStates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(countryId) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              url = "/api/countries/".concat(countryId, "/states");
              config = createRequestConfig();
              _context18.next = 4;
              return request.get(url, config);
            case 4:
              response = _context18.sent;
              return _context18.abrupt("return", response.data);
            case 6:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));
      function getCountryStates(_x44) {
        return _getCountryStates.apply(this, arguments);
      }
      return getCountryStates;
    }(),
    associateOrderWithUser: function () {
      var _associateOrderWithUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(order, authToken) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              url = "/api/orders/".concat(order.number, "/associate_user?order_token=").concat(order.token);
              config = createRequestConfig({
                authToken: authToken
              });
              _context19.next = 4;
              return request.put(url, null, config);
            case 4:
              response = _context19.sent;
              return _context19.abrupt("return", response.data);
            case 6:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
      function associateOrderWithUser(_x45, _x46) {
        return _associateOrderWithUser.apply(this, arguments);
      }
      return associateOrderWithUser;
    }(),
    getCurrentUser: function () {
      var _getCurrentUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(authToken) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              url = '/api/users/me';
              config = createRequestConfig({
                authToken: authToken
              });
              _context20.next = 4;
              return request.get(url, config);
            case 4:
              response = _context20.sent;
              return _context20.abrupt("return", response.data);
            case 6:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      function getCurrentUser(_x47) {
        return _getCurrentUser.apply(this, arguments);
      }
      return getCurrentUser;
    }(),
    getUserWallet: function () {
      var _getUserWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(authToken) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              url = '/api/wallet_payment_sources';
              config = createRequestConfig({
                authToken: authToken
              });
              _context21.next = 4;
              return request.get(url, config);
            case 4:
              response = _context21.sent;
              return _context21.abrupt("return", response.data);
            case 6:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }));
      function getUserWallet(_x48) {
        return _getUserWallet.apply(this, arguments);
      }
      return getUserWallet;
    }(),
    getUserOrders: function () {
      var _getUserOrders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(authToken, includeDetails, legacyEndpoint) {
        var page,
          perPage,
          url,
          config,
          params,
          response,
          _args22 = arguments;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              page = _args22.length > 3 && _args22[3] !== undefined ? _args22[3] : 1;
              perPage = _args22.length > 4 && _args22[4] !== undefined ? _args22[4] : 6;
              url = legacyEndpoint === false ? '/api/orders/completed' : '/api/orders/mine';
              config = createRequestConfig({
                authToken: authToken
              });
              params = {
                include_details: includeDetails === true ? includeDetails : undefined,
                page: page,
                per_page: perPage
              };
              _context22.next = 7;
              return request.get(url, _objectSpread(_objectSpread({}, config), {}, {
                params: params
              }));
            case 7:
              response = _context22.sent;
              return _context22.abrupt("return", response.data);
            case 9:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }));
      function getUserOrders(_x49, _x50, _x51) {
        return _getUserOrders.apply(this, arguments);
      }
      return getUserOrders;
    }(),
    getUserAddressBook: function () {
      var _getUserAddressBook = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(authToken, userId) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              url = "/api/users/".concat(userId, "/address_book");
              config = createRequestConfig({
                authToken: authToken
              });
              _context23.next = 4;
              return request.get(url, config);
            case 4:
              response = _context23.sent;
              return _context23.abrupt("return", response.data);
            case 6:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }));
      function getUserAddressBook(_x52, _x53) {
        return _getUserAddressBook.apply(this, arguments);
      }
      return getUserAddressBook;
    }(),
    updateUserAddressBook: function () {
      var _updateUserAddressBook = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(authToken, userId, address) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              url = "/api/users/".concat(userId, "/address_book");
              config = createRequestConfig({
                authToken: authToken
              });
              _context24.next = 4;
              return request.patch(url, address, config);
            case 4:
              response = _context24.sent;
              return _context24.abrupt("return", response.data);
            case 6:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }));
      function updateUserAddressBook(_x54, _x55, _x56) {
        return _updateUserAddressBook.apply(this, arguments);
      }
      return updateUserAddressBook;
    }(),
    removeFromUserAddressBook: function () {
      var _removeFromUserAddressBook = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(authToken, userId, addressId) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              url = "/api/users/".concat(userId, "/address_book?address_id=").concat(addressId);
              config = createRequestConfig({
                authToken: authToken
              });
              _context25.next = 4;
              return request.delete(url, config);
            case 4:
              response = _context25.sent;
              return _context25.abrupt("return", response.data);
            case 6:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }));
      function removeFromUserAddressBook(_x57, _x58, _x59) {
        return _removeFromUserAddressBook.apply(this, arguments);
      }
      return removeFromUserAddressBook;
    }(),
    getUserStoreCreditEvents: function () {
      var _getUserStoreCreditEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(authToken) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              url = '/api/store_credit_events/mine';
              config = createRequestConfig({
                authToken: authToken
              });
              _context26.next = 4;
              return request.get(url, config);
            case 4:
              response = _context26.sent;
              return _context26.abrupt("return", response.data);
            case 6:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      }));
      function getUserStoreCreditEvents(_x60) {
        return _getUserStoreCreditEvents.apply(this, arguments);
      }
      return getUserStoreCreditEvents;
    }(),
    updateUser: function () {
      var _updateUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(authToken, userId, data) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              url = "/api/users/".concat(userId);
              config = createRequestConfig({
                authToken: authToken
              });
              _context27.next = 4;
              return request.patch(url, _objectSpread({
                id: userId
              }, data), config);
            case 4:
              response = _context27.sent;
              return _context27.abrupt("return", response.data);
            case 6:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }));
      function updateUser(_x61, _x62, _x63) {
        return _updateUser.apply(this, arguments);
      }
      return updateUser;
    }(),
    getSubscriptions: function () {
      var _getSubscriptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(authToken, userId) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              url = "/api/users/".concat(userId, "/subscriptions");
              config = createRequestConfig({
                authToken: authToken
              });
              _context28.next = 4;
              return request.get(url, config);
            case 4:
              response = _context28.sent;
              return _context28.abrupt("return", response.data);
            case 6:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }));
      function getSubscriptions(_x64, _x65) {
        return _getSubscriptions.apply(this, arguments);
      }
      return getSubscriptions;
    }(),
    getSubscription: function () {
      var _getSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(authToken, userId, subscriptionId) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              url = "/api/users/".concat(userId, "/subscriptions/").concat(subscriptionId);
              config = createRequestConfig({
                authToken: authToken
              });
              _context29.next = 4;
              return request.get(url, config);
            case 4:
              response = _context29.sent;
              return _context29.abrupt("return", response.data);
            case 6:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }));
      function getSubscription(_x66, _x67, _x68) {
        return _getSubscription.apply(this, arguments);
      }
      return getSubscription;
    }(),
    skipSubscription: function () {
      var _skipSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(authToken, userId, subscriptionId) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              url = "/api/users/".concat(userId, "/subscriptions/").concat(subscriptionId, "/skip");
              config = createRequestConfig({
                authToken: authToken
              });
              _context30.next = 4;
              return request.post(url, null, config);
            case 4:
              response = _context30.sent;
              return _context30.abrupt("return", response.data);
            case 6:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      }));
      function skipSubscription(_x69, _x70, _x71) {
        return _skipSubscription.apply(this, arguments);
      }
      return skipSubscription;
    }(),
    cancelSubscription: function () {
      var _cancelSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(authToken, userId, subscriptionId) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              url = "/api/users/".concat(userId, "/subscriptions/").concat(subscriptionId, "/cancel");
              config = createRequestConfig({
                authToken: authToken
              });
              _context31.next = 4;
              return request.post(url, null, config);
            case 4:
              response = _context31.sent;
              return _context31.abrupt("return", response.data);
            case 6:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      }));
      function cancelSubscription(_x72, _x73, _x74) {
        return _cancelSubscription.apply(this, arguments);
      }
      return cancelSubscription;
    }(),
    updateSubscription: function () {
      var _updateSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(authToken, userId, subscriptionId, data) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              url = "/api/users/".concat(userId, "/subscriptions/").concat(subscriptionId);
              config = createRequestConfig({
                authToken: authToken
              });
              _context32.next = 4;
              return request.put(url, data, config);
            case 4:
              response = _context32.sent;
              return _context32.abrupt("return", response.data);
            case 6:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      }));
      function updateSubscription(_x75, _x76, _x77, _x78) {
        return _updateSubscription.apply(this, arguments);
      }
      return updateSubscription;
    }(),
    resumeSubscription: function () {
      var _resumeSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(authToken, userId, subscriptionId, date) {
        var url, config, data, response;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              url = "/api/users/".concat(userId, "/subscriptions/").concat(subscriptionId, "/resume");
              config = createRequestConfig({
                authToken: authToken
              });
              data = typeof date === 'object' && !(date instanceof Date) ? date : {
                actionableDate: date
              };
              _context33.next = 5;
              return request.post(url, data, config);
            case 5:
              response = _context33.sent;
              return _context33.abrupt("return", response.data);
            case 7:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }));
      function resumeSubscription(_x79, _x80, _x81, _x82) {
        return _resumeSubscription.apply(this, arguments);
      }
      return resumeSubscription;
    }(),
    pauseSubscription: function () {
      var _pauseSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(authToken, userId, subscriptionId, date) {
        var url, config, data, response;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              url = "/api/users/".concat(userId, "/subscriptions/").concat(subscriptionId, "/pause");
              config = createRequestConfig({
                authToken: authToken
              });
              data = typeof date === 'object' && !(date instanceof Date) ? date : {
                actionableDate: date
              };
              _context34.next = 5;
              return request.post(url, data, config);
            case 5:
              response = _context34.sent;
              return _context34.abrupt("return", response.data);
            case 7:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }));
      function pauseSubscription(_x83, _x84, _x85, _x86) {
        return _pauseSubscription.apply(this, arguments);
      }
      return pauseSubscription;
    }(),
    getVariantsBySkus: function () {
      var _getVariantsBySkus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(authToken, skus) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              url = '/api/variants';
              config = _objectSpread(_objectSpread({}, createRequestConfig({
                authToken: authToken
              })), {}, {
                params: {
                  'q[sku_in]': skus
                },
                paramsSerializer: function paramsSerializer(params) {
                  return qs.stringify(params, {
                    arrayFormat: 'bracket'
                  });
                }
              });
              _context35.next = 4;
              return request.get(url, config);
            case 4:
              response = _context35.sent;
              return _context35.abrupt("return", response.data);
            case 6:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }));
      function getVariantsBySkus(_x87, _x88) {
        return _getVariantsBySkus.apply(this, arguments);
      }
      return getVariantsBySkus;
    }(),
    createStockRequest: function () {
      var _createStockRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(data) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              url = '/api/stock_requests';
              config = createRequestConfig();
              _context36.next = 4;
              return request.post(url, data, config);
            case 4:
              response = _context36.sent;
              return _context36.abrupt("return", response.data);
            case 6:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }));
      function createStockRequest(_x89) {
        return _createStockRequest.apply(this, arguments);
      }
      return createStockRequest;
    }(),
    redeemGiftCard: function () {
      var _redeemGiftCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(redemptionCode, email) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              url = '/api/gift_cards/redeem';
              config = createRequestConfig();
              _context37.next = 4;
              return request.post(url, {
                redemptionCode: redemptionCode,
                email: email
              }, config);
            case 4:
              response = _context37.sent;
              return _context37.abrupt("return", response.data);
            case 6:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      }));
      function redeemGiftCard(_x90, _x91) {
        return _redeemGiftCard.apply(this, arguments);
      }
      return redeemGiftCard;
    }(),
    applyGiftCard: function () {
      var _applyGiftCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(order, authToken, redemptionCode, email) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              url = "/api/gift_cards/".concat(order.number, "/apply_gift_card");
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context38.next = 4;
              return request.post(url, {
                redemptionCode: redemptionCode,
                email: email
              }, config);
            case 4:
              response = _context38.sent;
              return _context38.abrupt("return", response.data);
            case 6:
            case "end":
              return _context38.stop();
          }
        }, _callee38);
      }));
      function applyGiftCard(_x92, _x93, _x94, _x95) {
        return _applyGiftCard.apply(this, arguments);
      }
      return applyGiftCard;
    }(),
    removeGiftCard: function () {
      var _removeGiftCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(order, authToken, redemptionCode) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              url = "/api/gift_cards/".concat(order.number, "/remove_gift_card/").concat(redemptionCode);
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context39.next = 4;
              return request.delete(url, config);
            case 4:
              response = _context39.sent;
              return _context39.abrupt("return", response.data);
            case 6:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      }));
      function removeGiftCard(_x96, _x97, _x98) {
        return _removeGiftCard.apply(this, arguments);
      }
      return removeGiftCard;
    }(),
    removeGiftCardItem: function () {
      var _removeGiftCardItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(order, authToken, redemptionCode) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              url = "/api/orders/".concat(order.number, "/remove_gift_card/").concat(redemptionCode);
              config = createRequestConfig({
                authToken: authToken,
                orderToken: order.token
              });
              _context40.next = 4;
              return request.delete(url, config);
            case 4:
              response = _context40.sent;
              return _context40.abrupt("return", response.data);
            case 6:
            case "end":
              return _context40.stop();
          }
        }, _callee40);
      }));
      function removeGiftCardItem(_x99, _x100, _x101) {
        return _removeGiftCardItem.apply(this, arguments);
      }
      return removeGiftCardItem;
    }(),
    redeemPrepaidSubscription: function () {
      var _redeemPrepaidSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(input) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              url = '/api/gift_cards/redeem';
              config = createRequestConfig();
              _context41.next = 4;
              return request.post(url, input, config);
            case 4:
              response = _context41.sent;
              return _context41.abrupt("return", response.data);
            case 6:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      }));
      function redeemPrepaidSubscription(_x102) {
        return _redeemPrepaidSubscription.apply(this, arguments);
      }
      return redeemPrepaidSubscription;
    }(),
    checkRedemptionCodeValidity: function () {
      var _checkRedemptionCodeValidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(redemptionCode, email) {
        var url, config, response;
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              url = "/api/gift_cards/redeem";
              config = _objectSpread(_objectSpread({}, createRequestConfig()), {}, {
                params: {
                  redemption_code: redemptionCode,
                  email: email
                },
                paramsSerializer: function paramsSerializer(params) {
                  return qs.stringify(params, {
                    arrayFormat: 'bracket'
                  });
                }
              });
              _context42.next = 4;
              return request.get(url, config);
            case 4:
              response = _context42.sent;
              return _context42.abrupt("return", response.data);
            case 6:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      }));
      function checkRedemptionCodeValidity(_x103, _x104) {
        return _checkRedemptionCodeValidity.apply(this, arguments);
      }
      return checkRedemptionCodeValidity;
    }(),
    getVariantStockAvailability: function () {
      var _getVariantStockAvailability = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(_ref2) {
        var sku, params, url, config, response;
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              sku = _ref2.sku, params = _objectWithoutProperties(_ref2, _excluded);
              url = "/api/variants/".concat(sku, "/stock_availabilities");
              config = _objectSpread(_objectSpread({}, createRequestConfig()), {}, {
                params: params
              });
              _context43.next = 5;
              return request.get(url, config);
            case 5:
              response = _context43.sent;
              return _context43.abrupt("return", response.data);
            case 7:
            case "end":
              return _context43.stop();
          }
        }, _callee43);
      }));
      function getVariantStockAvailability(_x105) {
        return _getVariantStockAvailability.apply(this, arguments);
      }
      return getVariantStockAvailability;
    }(),
    getVariantPrice: function () {
      var _getVariantPrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(_ref3) {
        var sku, params, url, config, response;
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              sku = _ref3.sku, params = _objectWithoutProperties(_ref3, _excluded2);
              url = "/api/variants/".concat(sku, "/discount_prices");
              config = _objectSpread(_objectSpread({}, createRequestConfig()), {}, {
                params: {
                  quantity: params.quantity,
                  interval_length: params.intervalLength,
                  interval_units: params.intervalUnits
                }
              });
              _context44.next = 5;
              return request.get(url, config);
            case 5:
              response = _context44.sent;
              return _context44.abrupt("return", response.data);
            case 7:
            case "end":
              return _context44.stop();
          }
        }, _callee44);
      }));
      function getVariantPrice(_x106) {
        return _getVariantPrice.apply(this, arguments);
      }
      return getVariantPrice;
    }()
  };
  return client;
};